import { render, staticRenderFns } from "./EmployeeFeedback.vue?vue&type=template&id=4e485a09&scoped=true&"
import script from "./EmployeeFeedback.vue?vue&type=script&setup=true&lang=js&"
export * from "./EmployeeFeedback.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./EmployeeFeedback.vue?vue&type=style&index=0&id=4e485a09&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e485a09",
  null
  
)

export default component.exports